import React from "react";
import styles from "./index.module.scss";
// import { useIntl, history, useModel } from 'umi';
import Logo from "../../components/Logo";

export type LoadingProps = {};

const Loading: React.FC<LoadingProps> = (props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        {/* <div>
          <Logo path="/" />
        </div> */}
        <div style={{ marginTop: 50 }}>กำลังโหลดข้อมูล...</div>
      </div>
    </div>
  );
};
export default Loading;
